import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Login from "../authentication/Login";
import ForgetPassword from "../authentication/ForgetPassword";
import ResetPassword from "../authentication/ResetPassword";
import VerificationPage from "../authentication/VerificationPage";

import Register from "../authentication/Register";
import Logo from "../../images/Viridi.png";
import Dashboard from "../dashboard/Index";
import Manageprofile from "../manageprofile/index";
import Myprofile from "../myprofile/myprofile";
import Businessunit from "../businessunit/businessunit";
import Businessunitdetail from "../business-unitdetails/business_unit_detl";
import Addbusinessunit from "../add-business-unit/add_business_unit";
import EditBusinessUnit from "../add-business-unit/editBusinessUnit";
import Department from "../department/department";
import Departmentdetl from "../department_details/department_details";
import Adddepartment from "../add-department/add_department";
import EditDepartment from "../add-department/EditDepartment";

import User from "../user/user";
import Adduser from "../add-user/add_user";
import EditUser from "../add-user/EditUser";
import Userdetails from "../user-details/user_details";
import Vat from "../others/vat/Vat";
import Esprovider from "../others/esprovider/Esprovider";
import Unspsc from "../others/unspsc/Unspsc";
import Co2 from "../others/co2/Co2";
import Currency from "../others/currency/Currency";
import Industry from "../others/industry/Industry";
import Segment from "../others/segment/Segment";
import Qualitycontrol from "../others/qualitycontrol/Qualitycontrol";
import Invoice from "../invoice/Invoice";
import Invoicedetails from "../invoice/Invoicedetails";
import Pastorder from "../orders/Pastorder";
import Order from "../orders/Order";
import Pastorderdetail from "../orders/Pastorderdetail";
import Purchaseorderlist from "../orders/Purchaseorderlist";
import Products from "../products/Products";
import Addproduct from "../products/Addproduct";
import Productdetails from "../products/Productdetails";
import Suppliers from "../suppliers/Suppliers";
import Addsuppliers from "../suppliers/Addsuppliers";
import Supplierdetailsinfo from "../suppliers/Supplierdetailsinfo";
import Supplierdetails from "../suppliers/Supplierdetails";
import Pastorderedit from "../orders/Pastorderedit";
import Purchaseorderdetail from "../orders/Purchaseorderdetail";
import Createpastorder from "../orders/Createpastorder";
import Createpurchaseorder from "../orders/Createpurchaseorder";
import Aboutus from "../aboutus/Aboutus";
import Contactus from "../contactus/Contactus";
import Terms from "../terms/Terms";
import Privacy from "../privacy/Privacy";
import GHG from "../others/ghg/GHG";
import GL from "../others/gl/GL";
import Pastorderedit1 from "../orders/Pastorderedit1";
import Faq from "../faq/Faq";
import AccountingDimensions from "../others/Accountingdimensions/AccountingDimensions";
import ConfigurationFaq from "../configuration-faq/ConfigurationFaq";
import OrderFaq from "../order-faq/OrderFaq";
import InvoiceFaq from "../invoice-faq/InvoiceFaq";
import ProductFaq from "../product-faq/ProductFaq";
import SupplierFaq from "../supplier-faq/SupplierFaq";
import SearchAllUNSPSC from "../search-all-unspsc/SearchAllUNSPSC";
import Service from "../service/Service";
import Solution from "../solution/Solution";
import AccountingDimensionsList from "../others/Accountingdimensions/AccountingDimensionsList";
import EditAccountingDimensions from "../others/Accountingdimensions/EditAccountingDimensions";
import AccessToken from "../accessToken/AccessToken";
import SegmentCopy from "../others/segment/SegmentCopy";
import ChangePassword from "../ChangePassword/ChangePassword";
import UnitsOfMeasure from "../others/unitsofmeasure/UnitsOfMeasure";
import News from "../News/News";
import NewsDetails from "../News/NewsDetails";
import Report from "../Report/Report";

// console.log(localStorage.getItem("gs3_AuthToken"));

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const _CHECK_AUTH = () => {
    if (localStorage.getItem("gs3_AuthToken") || queryParams.get("token")) {
      //  navigate('/dashboard')
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    _CHECK_AUTH();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Login logo={Logo} />} />
      <Route path="/forgotpassword" element={<ForgetPassword logo={Logo} />} />
      <Route path="/changepassword" element={<ChangePassword logo={Logo} />} />
      <Route path="/resetpassword" element={<ResetPassword logo={Logo} />} />
      <Route path="/register" element={<Register logo={Logo} />} />
      <Route path="/dashboard" element={<Dashboard logo={Logo} />} />
      <Route
        path="/verification-page"
        element={<VerificationPage logo={Logo} />}
      />
      <Route path="/manageprofile" element={<Manageprofile logo={Logo} />} />
      <Route path="/myprofile" element={<Myprofile logo={Logo} />} />
      <Route path="/businessunit" element={<Businessunit logo={Logo} />} />
      <Route
        path="/businessunitdetl"
        element={<Businessunitdetail logo={Logo} />}
      />
      <Route
        path="/addbusinessunit"
        element={<Addbusinessunit logo={Logo} />}
      />
      <Route
        path="/editbusinessunit"
        element={<EditBusinessUnit logo={Logo} />}
      />
      <Route path="/department" element={<Department logo={Logo} />} />
      <Route path="/departmentdetl" element={<Departmentdetl logo={Logo} />} />
      <Route path="/adddepartment" element={<Adddepartment />} />
      <Route path="/editdepartment" element={<EditDepartment />} />
      <Route path="/user" element={<User />} />
      <Route path="/adduser" element={<Adduser />} />
      <Route path="/edituser" element={<EditUser />} />
      <Route path="/userdetails" element={<Userdetails />} />
      <Route path="/vat" element={<Vat />} />
      <Route path="/esprovider" element={<Esprovider />} />
      <Route path="/unspsc" element={<Unspsc />} />
      <Route path="/co2" element={<Co2 />} />
      <Route path="/currency" element={<Currency />} />
      <Route path="/industry" element={<Industry />} />
      <Route path="/segment" element={<Segment />} />
      <Route path="/segmentcopy" element={<SegmentCopy />} />
      <Route path="/qualitycontrol" element={<Qualitycontrol />} />
      <Route path="/invoice" element={<Invoice />} />
      <Route path="/invoicedetails" element={<Invoicedetails />} />
      <Route path="/order" element={<Order />} />
      <Route path="/pastorder" element={<Pastorder />} />
      <Route path="/createpastorder" element={<Createpastorder />} />
      <Route path="/pastorderdetail" element={<Pastorderdetail />} />
      <Route path="/purchaseorder" element={<Purchaseorderlist />} />
      <Route path="/products" element={<Products />} />
      <Route path="/addproduct" element={<Addproduct />} />
      <Route path="/productdetails" element={<Productdetails />} />
      <Route path="/suppliers" element={<Suppliers />} />
      <Route path="/addsuppliers" element={<Addsuppliers />} />
      <Route path="/supplierdetailsinfo" element={<Supplierdetailsinfo />} />
      <Route path="/supplierdetails" element={<Supplierdetails />} />
      <Route path="/pastorderedit" element={<Pastorderedit />} />
      <Route path="/pastorderedit1" element={<Pastorderedit1 />} />
      <Route path="/purchaseorderdetail" element={<Purchaseorderdetail />} />
      <Route path="/createpurchaseorder" element={<Createpurchaseorder />} />
      <Route path="/aboutus" element={<Aboutus logo={Logo} />} />
      <Route path="/contactus" element={<Contactus />} />
      <Route path="/news" element={<News />} />
      <Route path="/newsdetails" element={<NewsDetails />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/ghg" element={<GHG />} />
      <Route path="/gl" element={<GL />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/unitsofmeasure" element={<UnitsOfMeasure />} />
      <Route path="/accounting-dimensions" element={<AccountingDimensions />} />
      <Route path="/configuration-Faq" element={<ConfigurationFaq />} />
      <Route path="/orderfaq" element={<OrderFaq />} />
      <Route path="/invoicefaq" element={<InvoiceFaq />} />
      <Route path="/productfaq" element={<ProductFaq />} />
      <Route path="/supplierfaq" element={<SupplierFaq />} />
      <Route path="/search-all-unspsc" element={<SearchAllUNSPSC />} />
      <Route path="/service" element={<Service />} />
      <Route path="/solution" element={<Solution />} />
      <Route path="/report" element={<Report />} />
      <Route
        path="/accounting-dimension-list"
        element={<AccountingDimensionsList />}
      />
      <Route
        path="/edit-accounting-dimensions"
        element={<EditAccountingDimensions />}
      />
      <Route path="/access-token" element={<AccessToken />} />
      {/* <Route path='/solution' */}
      {/* <Route path='/search-all-unspsc' element={<SearchAllUNSPSC />} />
        <Route path='/search-all-unspsc' element={<SearchAllUNSPSC />} /> */}
    </Routes>
  );
};

export default Index;
